import { ApiResponse } from "@/interfaces/api-response";
import { User } from "@/interfaces/user.interface";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "users";

const getMe = async () => {
  try {
    const response = await apiClient.get<ApiResponse<User>>(`/${SERVICE_ENDPOINT}/me`);
    return response?.data ?? null;
  } catch (error) {
    console.log("Error fetching current user:", error);
    return null;
  }
};

const getOneById = async (id: string) => {
  try {
    const response = await apiClient.get<ApiResponse<User>>(
      `/${SERVICE_ENDPOINT}/${id}`,
    );
    return response?.data;
  } catch (error) {
    console.log("Error fetching user by ID:", error);
    return null;
  }
};

const getMany = async (params?: Record<string, string>) => {
  try {
    const response = await apiClient.get(
      `/${SERVICE_ENDPOINT}/my-organization`,
      { params },
    );
    return response?.data;
  } catch (error) {
    console.log("Error fetching users:", error);
    return null;
  }
};
const createNew = async (user: Partial<User>) => {
  try {
    const response = await apiClient.post<ApiResponse<User>>(
      `/${SERVICE_ENDPOINT}`,
      user,
    );
    return response?.data;
  } catch (error) {
    console.log("Error creating new user:", error);
    return null;
  }
};

const update = async (user: Partial<User>) => {
  const response = await apiClient.put<ApiResponse<User>>(
    `/${SERVICE_ENDPOINT}/${user._id}`,
    user,
  );
  return response.data;
};

const userApi = {
  getMe,
  getOneById,
  getMany,
  createNew,
  update,
};

export default userApi;
